// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__QtoK0","paramInput":"JobSimulator_paramInput__10QXn","input":"JobSimulator_input__P7wau"};